<template>
    <div class="OSL-MC">
        <MobileHeader></MobileHeader>
        <router-view></router-view>
        <!-- <MpbileFooter></MpbileFooter> -->
    </div>

</template>
<script>
    import MobileHeader from '../components/Mobile/MobileHeader'
    // import MpbileFooter from '../components/Mobile/MobileFooter'
    export default {
        name: 'MobileContainer',
        components: {
            MobileHeader,
            // MpbileFooter
        }
    }
</script>
<style lang="scss" scoped>
.OSL-MC {
    width: 100%;
    height: 100%;
    position: relative;
   
}
</style>